import React from 'react';

import PropTypes from 'prop-types';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { DELIVERY_CASH_UNITELLER } from 'apps/auth/constants/Constants';
import { formatMoney } from 'apps/auth/helpers/formats';
import { resolveArguments } from 'apps/auth/helpers/utils';
import { LimitsService } from 'apps/auth/services/LimitsService';

import ExceedTransactionLimit from './ExceedTransactionLimit';
import ViewPopup from './ViewPopup';

const UsaPopup = ({
    popupRef,
    decreaseAmountButtonClick,
    defaultDecreaseAmountButtonClick,
    value,
    maxAmount,
    isFrom,
    messages,
    extra,
    auth,
    currencyCode,
    deliveryMethod,
    lang,
    isBonus,
}) => {
    const { leftLimitAmount, profile, hasOtherDeliveryOption, increaseLimit, commission, additionalAmlLimit } = extra;
    const {
        isTransactionLimitUsa,
        minSumProfileLimit,
        hasUsaLimitErrors,
        minSumProfileLimitFrom,
        errorLimits,
        errorMessageMaxLimit,
        errorMessageLeftLimit,
        dateEnd,
    } = LimitsService.getUsaLimitsErrors(value, maxAmount, auth?.countryId, currencyCode, isFrom, commission, profile, lang);
    const isZeroRemainingProfileLimits = minSumProfileLimit === 0;
    const toLeftLimitAmount = leftLimitAmount && extra?.commission?.convertRate && Number((+leftLimitAmount * +extra?.commission?.convertRate).toFixed(2));
    const isShowDeliveryOptions = hasOtherDeliveryOption && isTransactionLimitUsa && !isBonus;
    const isShowChangePickupButton = deliveryMethod === DELIVERY_CASH_UNITELLER && isTransactionLimitUsa && !isBonus;
    const isAdditionalSendingLimits = additionalAmlLimit && value > additionalAmlLimit.left;
    const isZeroAdditionalLimits = additionalAmlLimit && LimitsService.getZeroAdditionalLimitsErrors(value, additionalAmlLimit);

    const messagesMap = {
        DAILY: {
            title: messages.usaErrorDailyTitle,
            subTitle: messages.usaErrorDailySubTitle,
        },
        MONTHLY: {
            title: messages.usaErrorMonthlyTitle,
            subTitle: messages.usaErrorCommonSubtitle,
        },
        HALF_YEARLY: {
            title: messages.usaErrorSemiAnnualTitle,
            subTitle: messages.usaErrorCommonSubtitle,
        },
    };
    const getErrorTextBonus = () => {
        if (Number(value) > Number(maxAmount)) {
            const amountText = `${formatMoney(maxAmount)} ${currencyCode}`;
            return <DangerouslyHtml dangerouslyHtml={resolveArguments(messages.bonusAmountReached, [amountText])} />;
        } else if (leftLimitAmount && Number(value) > leftLimitAmount) {
            const amountText = `${formatMoney(isFrom ? leftLimitAmount : toLeftLimitAmount)} ${currencyCode}`;
            return <DangerouslyHtml dangerouslyHtml={resolveArguments(messages.bonusAmountLimitReached, [amountText])} />;
        } else if (isAdditionalSendingLimits) {
            return <DangerouslyHtml dangerouslyHtml={isFrom ? messages.additionalLimitErrorText : messages.errorTextAdditionalLimitLeftAmount} />;
        }
    };
    const getErrorText = () => {
        if (isTransactionLimitUsa) {
            return (
                <ExceedTransactionLimit
                    isFrom={isFrom}
                    isShowChangePickupButton={isShowChangePickupButton}
                    isShowDeliveryOptions={isShowDeliveryOptions}
                    messages={messages}
                />
            );
        } else if (isAdditionalSendingLimits) {
            return <DangerouslyHtml dangerouslyHtml={isFrom ? messages.additionalLimitErrorText : messages.errorTextAdditionalLimitLeftAmount} />;
        } else {
            return (
                <>
                    {resolveArguments(messagesMap[errorLimits]?.title, [errorMessageMaxLimit])}
                    <br />
                    {isZeroRemainingProfileLimits
                        ? resolveArguments(messages.usaErrorLimitReset, [dateEnd])
                        : resolveArguments(messagesMap[errorLimits]?.subTitle, [errorMessageLeftLimit, dateEnd])}
                </>
            );
        }
    };
    return (
        <ViewPopup
            isShowChangeAmountButton={hasUsaLimitErrors && !isZeroRemainingProfileLimits && !isZeroAdditionalLimits}
            isShowGotItButton={isZeroRemainingProfileLimits && !increaseLimit}
            isShowDeliveryOptions={isShowDeliveryOptions}
            isShowChangePickupButton={isShowChangePickupButton}
            deliveryMethod={deliveryMethod}
            isShowIncreaseLimitButton={increaseLimit && !isTransactionLimitUsa}
            defaultDecreaseAmountButtonClick={defaultDecreaseAmountButtonClick}
            decreaseAmountButtonClick={decreaseAmountButtonClick}
            popupRef={popupRef}
            errorText={isBonus ? getErrorTextBonus() : getErrorText()}
            profile={profile}
            messages={messages}
            arrowButtonText={messages.calcCommissionIncreaseLimit}
            minSumProfileLimitFrom={minSumProfileLimitFrom}
        />
    );
};
UsaPopup.propTypes = {
    decreaseAmountButtonClick: PropTypes.func,
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    value: PropTypes.number,
    maxAmount: PropTypes.number,
    isFrom: PropTypes.bool,
    messages: PropTypes.object,
    extra: PropTypes.object,
    auth: PropTypes.object,
    lang: PropTypes.string,
    deliveryMethod: PropTypes.string,
};
export default UsaPopup;
